import { render } from "./EnviadaComponent.vue?vue&type=template&id=2ba7e806"
import script from "./EnviadaComponent.vue?vue&type=script&lang=js"
export * from "./EnviadaComponent.vue?vue&type=script&lang=js"

import "./EnviadaComponent.vue?vue&type=style&index=0&id=2ba7e806&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__